module.exports = __webpack_public_path__ + "static/Lizard-4e98413b7d6e1b4b40d87f28ebe08835.jpg";